import { render, staticRenderFns } from "./transacoes-online.vue?vue&type=template&id=28e1fc7c&"
import script from "./transacoes-online.vue?vue&type=script&lang=js&"
export * from "./transacoes-online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports